import { setDateWithTimezone as o } from "./date-time-format.mjs";
const i = (t, e) => o(t, e);
export {
  i as getDate
};
